export enum RuleOperator {
    EQUALS = 'equals',
    NOT_EQUALS = 'not_equals',
    CONTAINS = 'contains',
    NOT_CONTAINS = 'not_contains',
    IN = 'in',
    NOT_IN = 'not_in'
}
